import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./ChequeBookRequest.css";
import { Box, Divider, Typography } from "@material-ui/core";

export default function ChequeBookFormRequestErrRes(props) {
  // let status_title;
  let cheque_book_form_response;
  let masked_accountNo;
  props.cbrFormData.map((item, i) => {
    // console.log("item from form err res: ", item);
    cheque_book_form_response = item.additionalinfo.excepMetaData;
    masked_accountNo = item.additionalinfo.Account_Number;
    // status_title = `Cheque Book Request Status For ${masked_accountNo}`
    // console.log("cheque_book_form_response: ", cheque_book_form_response);
  });

  return (
    <>
      <div className="cbr-content-wrapper cbr-content-wrapper-bot cbr-content-wrapper-border cbr-width-70">
        <Box>
          <Typography align="center" variant="subtitle2" display="block">
            Cheque Book Request Status For {masked_accountNo}
          </Typography>
        </Box>
        <Divider variant="middle" />
        <Box className="box-message">
          <Typography align="center" component="subtitle1">
            {cheque_book_form_response}. Please Contact Your Home Branch.
          </Typography>
        </Box>
      </div>
    </>
  );
}
